// Export original entities from original

import * as ko from "knockout";
export * from "../original";

// For each overridden entity with the same name, import it specifically and re-export it to allow overriding the original export
// IMPORTANT: Export child entities first, and parent entities later to prevent circular dependency problems

import { request_unit } from "./request_unit";
export { request_unit };

// New entities or new entities that extend original entities can be exported directly here:

export * from "./screenNote";
export * from "./warranty_mk";
export * from "./warranty_defective_part";
export * from "./calendar_exception";
export * from "./SearchResult";

export let loadRelation = (source, relation, relationName, relationType) => {
  if (source[relationName]) {
    if (!relationName) {
      throw "Relationship entity '" + relationName + "' needs to be defined in entities.ts.";
    }
    if (Array.isArray(source[relationName])) {
      return ko.observableArray(
        ko.utils.arrayMap(source[relationName], function (c) {
          return new relation(c);
        })
      );
    } else {
      var relationEntity = new relation(source[relationName]);
      if (relationType == "array") {
        return ko.observableArray([relationEntity]);
      } else {
        return ko.observable(relationEntity);
      }
    }
  }
  if (relationType == "array") {
    return ko.observableArray();
  } else {
    return ko.observable(null);
  }
};

export let changeTracker = (objectToTrack, hashFunction?) => {
  hashFunction = hashFunction || ko.toJSON;
  var lastCleanState = ko.observable(hashFunction(objectToTrack));

  var result = {
    isDirty: ko.computed(function () {
      return hashFunction(objectToTrack) != lastCleanState();
    }),
    markCurrentStateAsClean: function () {
      lastCleanState(hashFunction(objectToTrack));
    },
  };

  return function () {
    return result;
  };
};
